'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import ReactFocusLock from 'react-focus-lock';
import { useModal } from './ModalContext';
import { ModalOverlay } from './ModalOverlay';
import { Portal } from '../../utils/Portal';
import { RemoveScroll } from 'react-remove-scroll';
export const ModalPortal = ({ children }) => {
    const { isOpen } = useModal();
    return (_jsx(Portal, { children: _jsx(RemoveScroll, { enabled: isOpen, children: _jsx(ReactFocusLock, { disabled: !isOpen, returnFocus: true, children: _jsx(ModalOverlay, { children: children }) }) }) }));
};
